const order = {
  orderTeachingSubjectsAlphabetically: function(a, b) {
    var textA = a.category.toUpperCase();
    var textB = b.category.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  },

  orderByCategory: function(a, b) {
    var textA = a.Category.toUpperCase();
    var textB = b.Category.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  },

  orderByName: function(a, b) {
    var textA = a.Name.toUpperCase();
    var textB = b.Name.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  },

  orderTeachingCategories: function(a, b) {
    return a.order < b.order ? -1 : a.order > b.order ? 1 : 0;
  },

  orderAccountsByAccountGroupName: function(a, b) {
    if (a.AccountGroup.Name < b.AccountGroup.Name) {
      return 1;
    }
    if (a.AccountGroup.Name > b.AccountGroup.Name) {
      return -1;
    }
    return 0;
  },

  orderByDateAdded: function(a, b) {
    if (a.Date_Added > b.Date_Added) {
      return -1;
    }
    if (a.Date_Added < b.Date_Added) {
      return 1;
    }
    return 0;
  },

  orderByDescriptionAlphabetically: function(a, b) {
    var textA = a.description.toUpperCase();
    var textB = b.description.toUpperCase();
    return textA < textB ? -1 : textA > textB ? 1 : 0;
  },

  orderByPermission: function(a, b) {
    var textA = a.Permission.Title.toUpperCase();
    var textB = b.Permission.Title.toUpperCase();
    return textA > textB ? -1 : textA < textB ? 1 : 0;
  }
};

export { order };
